import React, { useEffect } from 'react';
import { Field } from 'redux-form';
import {
  Header,
  Isotipo,
  Title,
  FormStyled,
  Error,
  SubTitle,
  Text
} from './styled';

import { Cover } from '@app/src/views/Login/Cover';
import { Button } from '@app/src/components/Button';

import { RenderInput } from '@app/src/views/Login/RenderInput';
import { required } from '@app/src/utils/validations';
import { validatePassword, validateSecurityPassword } from '@app/src/utils/validations';
import { ModalContainer } from './../Modal';
import { fetchValidationTokenEmail } from '@app/src/views/Login/createPassword/state/validateToken/actions';
import { getSettings } from '@app/src/configuration/config.service';

export const Form = ({
  handleSubmit,
  errorMessage,
  isFetching,
  reset,
  dispatch
}) => {
  useEffect(() => {
    dispatch(fetchValidationTokenEmail(getSettings().API_VALIDATION_TOKEN_EMAIL))
  }, []);

  return (
    <Cover>
      <Header>
        <Isotipo>
        <svg width="144" height="96" viewBox="0 0 144 96" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48 L48 0 L96 48 L48 96 Z" fill="#111" />
          <path d="M96 0 L144 48 L96 96 Z" fill="#111" />
        </svg>
        </Isotipo>
        <Title>Callcenter PagoEfectivo</Title>
      </Header>
      <FormStyled onSubmit={handleSubmit}>
        <SubTitle>Nueva contraseña</SubTitle>
        <Text>Crea una contraseña segura que no utilices en otros sitios web. Debe contener al menos 8 caracteres, al menos una letra mayúscula y minúscula, un número o caracter especial.</Text>
        <Error></Error>
        <Field
          name="newPassword"
          type="password"
          label="Crea una contraseña"
          maxLength={15}
          component={RenderInput}
          validate={[required, validateSecurityPassword]}
        />
        <Field
          name="password"
          type="password"
          label="Confirma la contraseña"
          maxLength={15}
          component={RenderInput}
          validate={[required, validatePassword]}
        />
        <Button type="submit" primary fullWidth loading={isFetching}>Enviar</Button>
      </FormStyled>
      <ModalContainer data-test="modal" reset={reset} errorMessage={errorMessage} />
    </Cover>
  );
}
